@if ({ customerPortalUrl: customerPortalUrl$ | async }; as data) {
  <div class="recruitment-box">
    <p class="recruitment-box__heading">{{ 'label.Recruiting' | translate }}</p>

    <div class="recruitment-box__points">
      <a class="recruitment-point" href="{{ data.customerPortalUrl }}/posting/new" target="_blank">
        <span class="recruitment-point__text">{{ 'label.RecruitingP1' | translate }}</span>
        <svg-icon src="/assets/icons/greater-sign.svg" class="recruitment-point__icon"></svg-icon>
      </a>
      <a class="recruitment-point" href="{{ data.customerPortalUrl }}/candidate-search" target="_blank">
        <span class="recruitment-point__text">{{ 'label.RecruitingP2' | translate }}</span>
        <svg-icon src="/assets/icons/greater-sign.svg" class="recruitment-point__icon"></svg-icon>
      </a>
    </div>

    <div class="recruitment-box__actions">
      <a class="recruitment-box__register" href="{{ data.customerPortalUrl }}/customer/register" target="_blank">
        {{ 'label.CompanyRegistration' | translate }}
      </a>
      <a class="recruitment-box__signin" href="{{ data.customerPortalUrl }}/sign-in" target="_blank">
        {{ 'label.CompanyLogin' | translate }}
      </a>
    </div>
  </div>
}
